export default __webpack_public_path__ + "static/media/academy-logo.51caa77b.png";